/**
 * Contenido editable de la landing "LA MUJER QUE OLVIDASTE SER™".
 * Todo el texto vive aquí para poder ajustarlo sin tocar los componentes.
 */

/** URL del checkout externo (Shopify). Todos los botones de compra apuntan aquí. */
export const CHECKOUT_URL =
  'https://punto-de-accion.myshopify.com/products/kit-de-reinicio-emocional-1'

export const PRICE = '$27 USD'
export const TOTAL_VALUE = '$150 USD'
export const CONTACT_EMAIL = '[INSERTAR EMAIL]'

export const emotionalCards = [
  'Ya no siento la misma ilusión.',
  'Extraño la mujer que era antes.',
  'Me cuesta pensar en mí sin sentir culpa.',
  'Siento que estoy funcionando, pero no viviendo.',
]

export const benefits = [
  'Entender por qué te desconectaste de ti',
  'Recuperar claridad sobre lo que quieres',
  'Mejorar la forma en la que te hablas',
  'Soltar culpa por elegirte',
  'Reconectar con tus sueños',
  'Recuperar confianza',
  'Volver a sentirte presente en tu propia vida',
]

export type Bonus = {
  label: string
  title: string
  value: string
  description: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    label: 'Bono 01',
    title: 'Diario Volver a Mí',
    value: '$19 USD',
    description:
      'Un diario guiado diseñado para ayudarte a expresar lo que sientes, ordenar tus pensamientos y volver a conectar con tus necesidades. Incluye preguntas de reflexión para recuperar claridad y autoestima.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/827fbca2-022f-4d1d-8db5-006be9f05cf8.jpg',
  },
  {
    label: 'Bono 02',
    title: 'Mi Coach Emocional con IA',
    value: '$47 USD',
    description:
      'Aprende a utilizar inteligencia artificial como una herramienta de reflexión emocional. Incluye prompts preparados para trabajar momentos de ansiedad, bloqueo, dudas, miedo y falta de claridad. Una herramienta para acompañarte cuando necesites ordenar tu mente.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e5ee77b7-7bb4-46d6-8cf9-fb795aa61fbe.jpg',
  },
  {
    label: 'Bono 03',
    title: '30 días para volver a elegirme',
    value: '$37 USD',
    description:
      'Un reto diario con pequeñas acciones para crear nuevamente el hábito de cuidarte, escucharte y darte prioridad. 30 días para fortalecer amor propio y confianza.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/b29176b5-ba03-422f-99da-f588446bedb6.jpg',
  },
]

export const valueStack = [
  { name: 'La Mujer que Olvidaste SER™', detail: 'Guía principal de 7 días', value: '$47' },
  { name: 'Diario Volver a Mí', detail: 'Bono 01', value: '$19' },
  { name: 'Mi Coach Emocional con IA', detail: 'Bono 02', value: '$47' },
  { name: '30 días para volver a elegirme', detail: 'Bono 03', value: '$37' },
]

export const transformationLines = [
  'Volver a tener claridad.',
  'Tomar decisiones desde la confianza.',
  'Dejar de sentir que siempre llegas tarde a tu propia vida.',
  'Mirarte con más amor.',
  'Recordar que tú también importas.',
]

export const forYouList = [
  'Sientes que perdiste parte de tu identidad',
  'Siempre estás disponible para otros pero poco para ti',
  'Te cuesta saber qué quieres',
  'Te sientes emocionalmente agotada',
  'Quieres comenzar una nueva etapa',
  'Extrañas sentir ilusión por tu vida',
]

export type Testimonial = {
  headline: string
  name: string
  age: string
  paragraphs: string[]
}

export const testimonials: Testimonial[] = [
  {
    headline: 'Volví a recordar quién era antes de perderme',
    name: 'Mariana',
    age: '38 años',
    paragraphs: [
      'Durante años sentí que estaba cumpliendo con todo, pero no conmigo. Era profesional, responsable, estaba pendiente de mi familia… pero cuando me preguntaban qué quería yo, no sabía qué responder.',
      'La Mujer que Olvidaste SER me ayudó a detenerme y hacerme preguntas que llevaba mucho tiempo evitando. No cambió mi vida de un día para otro, pero sí cambió la forma en la que empecé a mirarme.',
    ],
  },
  {
    headline: 'Dejé de sentir que estaba empezando desde cero',
    name: 'Carolina',
    age: '42 años',
    paragraphs: [
      'Después de muchos cambios en mi vida sentía que había perdido mi dirección. Me comparaba con otras personas y pensaba que estaba atrasada.',
      'Este proceso me recordó algo importante: no estaba empezando de cero, estaba empezando desde la experiencia. Volví a conectar con mis sueños y con la mujer que todavía quería construir una vida diferente.',
    ],
  },
  {
    headline: 'Aprendí que elegirme no era egoísmo',
    name: 'Laura',
    age: '35 años',
    paragraphs: [
      'Siempre fui la persona que resolvía todo. La que escuchaba. La que estaba para todos. Pero poco a poco me fui dejando al final de la lista.',
      'Los ejercicios del diario y las reflexiones me ayudaron a entender que cuidarme no significa querer menos a los demás. Significa dejar de abandonarme a mí.',
    ],
  },
  {
    headline: 'Volví a confiar en mí',
    name: 'Andrea',
    age: '45 años',
    paragraphs: [
      'Había perdido mucha confianza en mis decisiones. Pensaba demasiado todo y tenía miedo de equivocarme.',
      'Este proceso me ayudó a volver a escuchar mi propia voz y dar pequeños pasos sin esperar tener todo perfecto.',
    ],
  },
]

export const faqs = [
  {
    question: '¿Es un curso?',
    answer:
      'No. Es un kit digital práctico con una guía principal y tres bonos complementarios.',
  },
  {
    question: '¿Cuándo recibo acceso?',
    answer: 'Inmediatamente después de completar la compra.',
  },
  {
    question: '¿Cuánto tiempo necesito al día?',
    answer: 'Entre 10 y 20 minutos.',
  },
  {
    question: '¿Puedo hacerlo desde mi celular?',
    answer: 'Sí.',
  },
  {
    question: '¿Necesito experiencia previa?',
    answer:
      'No. Está diseñado para cualquier mujer que quiera reconectar consigo misma.',
  },
]

export const legalContent = {
  privacy: {
    title: 'Política de privacidad',
    paragraphs: [
      'En Punto de Acción respetamos tu privacidad. La información proporcionada durante la compra será utilizada únicamente para procesar tu pedido, entregar el producto digital y enviar comunicaciones relacionadas cuando exista autorización.',
      'No compartimos información personal con terceros sin consentimiento.',
      'El usuario puede solicitar actualización o eliminación de sus datos escribiendo al correo de contacto.',
    ],
  },
  terms: {
    title: 'Términos y condiciones',
    paragraphs: [
      'Este producto digital es para uso personal. Está prohibida la reproducción, distribución o comercialización del contenido sin autorización.',
      'El acceso es digital e inmediato.',
      'La compra implica aceptación de estos términos.',
    ],
  },
}
